/**
 * Форматирует число
 *
 * @param  {String|Number} value
 * @param  {String} [separator]
 * @return {String}
 */
export default function formatNumber(value, separator = ' ') {
    if (!value) {
        return '';
    }

    value = parseFloat(value);

    if (typeof (value.toLocaleString) === 'function') {
        value = value.toLocaleString('ru-RU').replace(',', separator);
    }

    return value;
}
